import { generatePath } from 'react-router-dom'
import { TabbedNavRoute } from 'app/navigation/interfaces'
import { brandVoicePath } from 'app/navigation/paths'
import { useFlags } from 'launchdarkly-react-client-sdk'

import SubNavBar, {
  SubNavItem,
  SubNavProps,
} from 'common/components/navigation/subNavBar'
import { useAppSelector } from 'common/hooks/redux'

type Props = SubNavProps & {
  routes: Pick<TabbedNavRoute, 'name' | 'to'>[]
  brandVoiceId: string | undefined
  accountId: string
}

const SubNavigation = ({ routes, brandVoiceId, accountId, ...rest }: Props) => {
  const flags = useFlags()
  const {
    editedContent: { brandVoices },
  } = useAppSelector((state) => state.brandVoice)

  if (!flags.showBrandTonePage) {
    return null
  }

  const currentBrandVoice = brandVoices.find((brandVoice) => {
    return brandVoice.id === brandVoiceId
  })

  const backLink = generatePath(brandVoicePath, { accountId })

  return (
    <SubNavBar {...rest} title={currentBrandVoice?.name} backLink={backLink}>
      {routes.map(({ name, to }) => (
        <SubNavItem
          key={name}
          title={name}
          to={generatePath(to, { accountId, brandVoiceId })}
        />
      ))}
    </SubNavBar>
  )
}

export default SubNavigation
